import React from 'react';
import { Card } from './ui/card';
import * as LucideIcons from 'lucide-react';
import { whyChooseUs } from '../mockData';

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="py-20 bg-gradient-to-br from-gray-50 via-emerald-50/30 to-purple-50/30 relative overflow-hidden">
      <div className="absolute top-20 right-20 w-72 h-72 bg-emerald-300/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-purple-300/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="h-1 w-16 bg-gradient-to-r from-emerald-500 to-purple-500 rounded-full mb-4 mx-auto"></div>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose US?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Building Business Resilience and Automation for your business
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item) => {
            const Icon = LucideIcons[item.icon];
            return (
              <Card
                key={item.id}
                className="p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-t-4 border-t-emerald-500 group cursor-pointer bg-white"
              >
                <div className="mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-2xl flex items-center justify-center group-hover:from-emerald-500 group-hover:to-emerald-600 transition-all">
                    <Icon className="w-8 h-8 text-emerald-600 group-hover:text-white transition-colors" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
